import { cn } from '../../lib/cn';

interface Props {
  children: React.ReactNode;
  /** `brand` pour les labels d'en-tête de bloc coloré (éditeurs, encarts). */
  tone?: 'mute' | 'brand';
  /**
   * Balise rendue. `div` par défaut (label de bloc). `span` quand le label
   * vit DANS une ligne de texte — un bloc y casserait le flux et le
   * `truncate` du parent. `h2`/`h3` quand le label est le titre réel d'une
   * section : le niveau de titre compte pour la navigation au lecteur
   * d'écran, et le composant ne doit pas le faire disparaître.
   */
  as?: 'div' | 'span' | 'h2' | 'h3';
  className?: string;
}

/**
 * Petit label de section en capitales — « KPIS », « ACTIVITÉ », « TOP
 * VENDEURS », « ROUTAGE »… Une seule signature typographique pour tout le
 * produit.
 *
 * Pourquoi un composant : ce label existait à 111 endroits sous 29
 * signatures différentes (7 tailles × 4 graisses × 3 espacements × 5
 * couleurs), avec un ordre de classes lui-même variable. L'écart se voyait
 * en passant d'un onglet à l'autre, et aucun rattrapage par recherche de
 * chaîne n'était possible.
 *
 * Le `className` reste ouvert pour la MISE EN PAGE et pour une couleur
 * héritée d'un encart (`text-warning` dans un bloc d'alerte) — pas pour la
 * taille ni la graisse : les redéfinir ici recrée le problème que ce
 * composant résout.
 */
export function SectionLabel({ children, tone = 'mute', as: Tag = 'div', className }: Props) {
  return (
    <Tag
      className={cn(
        'text-micro font-semibold uppercase tracking-[0.08em]',
        tone === 'brand' ? 'text-brand' : 'text-ink-mute',
        className,
      )}
    >
      {children}
    </Tag>
  );
}
